import {
  ADMIN_USER_TRANSACTIONS_PENDING_LOCATION,
  Arrow,
  Button,
  CreditCardStyled,
  Disclaimer,
  Div,
  ErrorToast,
  H2,
  Icon,
  IconButtonStyled,
  P,
  Pill,
  Separator,
  TrashIcon,
  VPayLogo,
  centsToDollars,
  displayCentsInDollars,
  formatter,
  lightTheme,
  useUsers,
} from '@vgrubs/components';
import { SimpleLocationEntity } from 'components/src/types/location.types';
import { useNavigate } from 'react-router-dom';

export const UserCreditCard = ({
  id,
  locations,
  isAgent = false,
}: {
  id: string | number;
  locations?: SimpleLocationEntity[];
  isAgent?: boolean;
}) => {
  const navigate = useNavigate();
  const {
    setEditBalanceModal,
    setDeleteBankModal,
    bank,
    setConnectYourBankModal,
  } = useUsers((state) => state);

  const handleEditBalanceModal = () => {
    if (!isAgent && locations && locations?.length < 1)
      return ErrorToast('User is not owner of any location.');
    setEditBalanceModal(true);
  };

  const handleConnectBank = () => {
    setConnectYourBankModal(true);
  };

  if (bank === null) return null;

  return (
    <CreditCardStyled>
      <Div $flex $alignCenter $between $gap="50px" $gapSM="24px">
        <VPayLogo height="100px" width="100px" />
        <Div $flex $column $alignEnd>
          <P $right $mb="4" $color={lightTheme.white}>
            Available Balance
          </P>
          <H2 $right $mb="4" $color={lightTheme.white}>
            {formatter.format(
              bank.balance.availableBalance
                ? centsToDollars(bank.balance.availableBalance)
                : 0
            )}
          </H2>
          {!isAgent && (
            <Pill
              $pointer
              $background={`${lightTheme.white}${lightTheme.transparency.t20}`}
              onClick={() =>
                navigate(
                  ADMIN_USER_TRANSACTIONS_PENDING_LOCATION.replace(
                    ':id',
                    id.toString()
                  )
                )
              }
            >
              <Div $p="4px" $flex $alignCenter $gap="8px">
                <P $m="0" $color={lightTheme.white}>
                  Pending{': '}
                  {displayCentsInDollars(bank?.pendingBalance ?? 0)}
                </P>
                <Icon $size="12" $color={lightTheme.white}>
                  <Arrow />
                </Icon>
              </Div>
            </Pill>
          )}
        </Div>
      </Div>
      <Separator
        $m="20px 0"
        $color={`${lightTheme.white}${lightTheme.transparency.t50}`}
      />
      <Div $flex $alignCenter $between $gap="24px" $gapSM="16px">
        {bank.isBankConnected && (
          <Div
            $flex
            $alignCenter
            $gap="12px"
            $gapSM="8px"
            onClick={() => setDeleteBankModal(true)}
          >
            <IconButtonStyled $color={lightTheme.primary}>
              <Icon $size="20" $sizeSM="16">
                <TrashIcon />
              </Icon>
            </IconButtonStyled>
            <Disclaimer $m="0" $color={lightTheme.white}>
              Bank Account: **{bank.bankLastFour}
              <br />
              Remove Bank Account{' '}
            </Disclaimer>
          </Div>
        )}

        <Button
          // $selected={bank.isBankConnected}
          $whiteBlue
          $w={bank.isBankConnected ? '150px' : '50%'}
          $wSM={bank.isBankConnected ? '110px' : '50%'}
          onClick={handleEditBalanceModal}
        >
          Edit Balance
        </Button>

        {!bank.isBankConnected && (
          <Button
            $selected
            $whiteBlue
            $w={bank.isBankConnected ? '150px' : '50%'}
            $wSM={bank.isBankConnected ? '110px' : '50%'}
            onClick={handleConnectBank}
          >
            Connect Bank
          </Button>
        )}
      </Div>
    </CreditCardStyled>
  );
};
